<div class="container-fluid pb-4 mb-4">
  <pos-app-spinner [show]="loading$ | async"></pos-app-spinner>

  <h3 class="text-center py-3 arb-large-heading">E-COMMERCE SEARCH</h3>

  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-4">
      <div class="searchBox d-flex justify-content-center align-items-center">
        <div class="position-relative w-100 my-2">
          <input
            #searchBox
            type="text"
            placeholder="Enter order number/ phone / email"
            class="form-control"
            autofocus
            [(ngModel)]="searchString"
            (focus)="isFocus($event)"
            (blur)="lostFocus($event)"
            (keyup)="onKeyboard($event)"
            maxlength="100"
          />
          <span class="position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%)" *ngIf="loading$ | async">
            <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
          </span>
        </div>
        <div class="d-flex justify-content-center w-50">
          <button type="button" class="btn w-100 d-flex align-items-center justify-content-center" (click)="onSearch()" [disabled]="loading$ | async">
            <mat-icon fontIcon="search" aria-hidden="false" aria-label="Search Icon"></mat-icon>
            <span class="ml-2 text-uppercase">Search</span>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="rowData?.length > 0">
      <ag-grid-angular
        #agGrid
        class="ag-theme-balham datagrid"
        [rowData]="rowData"
        [context]="context"
        [frameworkComponents]="frameworkComponents"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [domLayout]="'autoHeight'"
        [pagination]="true"
        [paginationPageSize]="20"
        [quickFilterText]="searchValue"
      ></ag-grid-angular>
    </div>
    <div *ngIf="rowData?.length === 0 && resultNotFound && !searchString" class="mt-4">
      <h5 class="text-center">No records found</h5>
  </div>
</div>
